import { Big } from 'foundations-components/transitional/components/Big';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Section } from 'foundations-components/transitional/components/Section';
import { MediaQueryView } from '../../layout/components/MediaQueryView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function StorefrontSection({
  children,
  primaryGridSize = 5,
  subtitle,
  title,
  titleControls,
  titleControlsMobile = 'sm'
}) {
  const secondaryGridSize = 12 - primaryGridSize;
  return /*#__PURE__*/_jsxs(Section, {
    children: [/*#__PURE__*/_jsxs(Grid, {
      marginBlockEnd: "700",
      children: [/*#__PURE__*/_jsxs(GridItem, {
        size: {
          xs: 12,
          sm: primaryGridSize
        },
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h3",
          marginBlockEnd: !subtitle ? '0' : undefined,
          children: title
        }), subtitle && /*#__PURE__*/_jsx(Big, {
          children: subtitle
        })]
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          sm: secondaryGridSize
        },
        children: /*#__PURE__*/_jsx(MediaQueryView, {
          min: titleControlsMobile,
          children: /*#__PURE__*/_jsx(Flex, {
            justifyContent: "end",
            children: titleControls
          })
        })
      })]
    }), children, /*#__PURE__*/_jsx(MediaQueryView, {
      max: titleControlsMobile,
      children: titleControls
    })]
  });
}